import { render } from "./AgedBalanceTable.vue?vue&type=template&id=51996f54"
import script from "./AgedBalanceTable.vue?vue&type=script&lang=js"
export * from "./AgedBalanceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__